//file imports
import { SortTextField, FilterSortTextField } from "../../Components/DropdownTextfield/DropdownTextfield";
import { getInspectionDataWithOutLoader } from "../../Redux/Actions/CommonActions";
import { reportLibrarySideBarToggle } from "../../Redux/Actions/CommonActions";
import { Divider, Grid, Typography, useMediaQuery } from "@mui/material";
import "../../../Assets/Styles/Containers/_reportLibrarySideBar.scss";
import { useDispatch, useSelector } from 'react-redux';
import { CloseIconAi, Gallery } from "../../../Assets/Svg/Svg";
import CloseIcon from '@mui/icons-material/Close';
import RLButtonGroup from "./RLButtonGroup";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import RMLGallery from "./RMLGallery";
import { v4 as uuidv4 } from 'uuid';
import { Base64 } from "js-base64";
/**
 * Component for the Report Library Sidebar
 */
const ReportLibrarySideBar = ({ selectedMediaFiles, selectedImages, setSelectedImages, setSelectedMediaFiles, onDragToggle, setOnDragToggle, value, name }) => {
    // redux
    const dispatch = useDispatch();
    //media query
    const isTab = useMediaQuery('(min-width: 900px) and (max-width: 1100px)');
    const isMobile = useMediaQuery('(max-width: 900px)');
    //filter 
    const [sortType, setSortType] = useState("Newest")
    const [selectedId, setSelectedId] = useState('All');
    const [selectedType, setSelectedType] = useState('All');
    // Boolean to track whether the sidebar is open or closed
    const [isOpen, setIsOpen] = useState(isMobile ? false : true);
    // Boolean to track whether the sidebar is hidden or not
    const [hidden, setHidden] = useState(!isOpen);
    // Store data from Redux store
    const storeData = useSelector((state) => state.CommonReducer);
    // Array of report library data
    const [reportLibraryData, setReportLibraryData] = useState([]);
    //filter data
    const [RLInitialData, setRLInititalData] = useState([]);

    const updateTimesUsedForDeleted = (data) => {
        // Create a map to store the count of total and deleted items for each UUID
        const uuidCounts = new Map();
        // First pass: count total and deleted items for each UUID
        data.forEach(item => {
            if (!uuidCounts.has(item.uuid)) {
                uuidCounts.set(item.uuid, { total: 0, deleted: 0 });
            }
            const counts = uuidCounts.get(item.uuid);
            counts.total += 1;
            if (item.is_deleted === 1) {
                counts.deleted += 1;
            }
        });

        // Second pass: update times_used based on the counts
        data.forEach(item => {
            const counts = uuidCounts.get(item.uuid);
            if (counts.total === counts.deleted) {
                // Set times_used to 0 if all items with the same UUID are deleted
                item.times_used = 0;
            } else {
                if (item.is_report_media_library_file) item.times_used = counts.total - counts.deleted - 1;
                // Otherwise, update times_used to reflect the number of non-deleted items
                else item.times_used = counts.total - counts.deleted;
            }
        });

        return filterArrayByUUID(data);
    };

    const filterArrayByUUID = (array) => {
        const uuidMap = new Map();

        // Reverse the array to process latest occurrences first
        array?.reverse()?.forEach(item => {
            // Prefer id, but fallback to uuid if id is not present
            const key = item.id || item.uuid;

            // If the key exists, compare and update the 'updated_at' field to the latest
            if (uuidMap.has(key)) {
                const existingItem = uuidMap.get(key);
                if (new Date(item.updated_at) > new Date(existingItem.updated_at)) {
                    existingItem.updated_at = item.updated_at; // Update the 'updated_at' field
                }
            } else {
                // Add the item to the map if it doesn't exist
                uuidMap.set(key, item);
            }
        });

        // Convert Map to an array and filter based on online status
        return test(Array.from(uuidMap.values()).filter(obj => {
            return !obj?.hasOwnProperty('online') || obj?.online === 'online';
        }));
    };

    useEffect(() => {
        dispatch(reportLibrarySideBarToggle(isOpen))
    }, [])

    function mergeObjectsByCategoryId(data) {
        const mergedObjects = {};
        data?.forEach((item) => {
            if (item) {
                [item].forEach((innerItem) => {
                    const categoryId = innerItem.category_id;
                    if (!mergedObjects[categoryId]) {
                        mergedObjects[categoryId] = { ...innerItem };
                    } else {
                        mergedObjects[categoryId].value = mergedObjects[categoryId]?.value?.concat(innerItem.value);
                    }
                });
            }
        });
        return Object.values(mergedObjects);
    }

    const FilterCommentNLineMedia = () => {
        let media = [];
        const templateMediaString = "template-editor/";
        storeData?.inspectionDataForBulkMedia?.data?.report_media_library_files?.forEach((item) => {
            // Template media never belongs in the report media library.
            if (item?.online_url?.startsWith(templateMediaString) || item?.thumbnail_url?.startsWith(templateMediaString)) {
                return;
            }
            media.push({ ...item, onlineUrl: item?.online_url, thumbnail: item?.thumbnail_url, type: item?.media_type, edited: false });
        });
        storeData?.inspectionDataForBulkMedia?.data?.inspectiontemplates?.forEach((template) => {
            if (template.is_pdf_template !== 1) {
                template?.categories?.forEach((category) => {
                    category?.introductory_text_media?.forEach((image) => {
                        if (image?.onlineUrl?.startsWith(templateMediaString) || image?.thumbnail?.startsWith(templateMediaString)) {
                            return;
                        }
                        let times_used = 1;
                        if (category?.is_deleted === 1 || image?.is_deleted === 1) {
                            times_used = 0;
                        }
                        if (image?.is_report_media_library_file) {
                            media?.push({ ...image, onlineUrl: image?.online_url, thumbnail: image?.thumbnail_url, type: image?.media_type, times_used: times_used });
                        } else {
                            media?.push({ ...image, online_url: image?.onlineUrl, thumbnail_url: image?.thumbnail, media_type: image?.type, times_used: times_used, template_media: true });
                        }
                    });
                    category?.lines?.forEach((line) => {
                        line?.line_input_controls !== null &&
                            line?.line_input_controls !== undefined &&
                            line?.line_input_controls.length !== 0 &&
                            line?.line_input_controls
                                ?.filter((data) => data.type === "Media")
                                ?.forEach((MediaData) => {
                                    MediaData?.data?.forEach((image) => {
                                        if (image?.onlineUrl?.startsWith(templateMediaString) || image?.thumbnail?.startsWith(templateMediaString)) {
                                            return;
                                        }
                                        let times_used = 1;
                                        if (category?.is_deleted === 1 || line?.is_deleted === 1 || image?.is_deleted === 1) {
                                            times_used = 0;
                                        }
                                        if (image?.is_report_media_library_file) {
                                            media.push({ ...image, onlineUrl: image?.online_url, thumbnail: image?.thumbnail_url, type: image?.media_type, times_used: times_used });
                                        } else {
                                            media?.push({ ...image, online_url: image?.onlineUrl, thumbnail_url: image?.thumbnail, media_type: image?.type, times_used: times_used, template_media: true });
                                        }
                                    });
                                });
                        line?.line_input_controls?.filter((data) => data?.type === "Nameplate")?.[0]?.data?.image &&
                            media.push(line?.line_input_controls?.filter((data) => data?.type === "Nameplate")?.[0]?.data?.image);
                        line?.comments?.length !== 0 &&
                            line?.comments?.forEach((comment) =>
                                comment?.comment_input_controls
                                    ?.filter((data) => data.type === "Media")
                                    ?.forEach((innerData) => {
                                        innerData?.data?.forEach((image) => {
                                            if (image?.onlineUrl?.startsWith(templateMediaString) || image?.thumbnail?.startsWith(templateMediaString)) {
                                                return;
                                            }
                                            let times_used = 1;
                                            if (image?.is_deleted === 1) {
                                                times_used = 0;
                                            }
                                            if (image?.is_report_media_library_file) {
                                                media.push({ ...image, onlineUrl: image?.online_url, thumbnail: image?.thumbnail_url, type: image?.media_type, times_used: times_used });
                                            } else {
                                                media?.push({ ...image, online_url: image?.onlineUrl, thumbnail_url: image?.thumbnail, media_type: image?.type, times_used: times_used, template_media: true });
                                            }
                                        });
                                    })
                            );
                    });
                });
            } else {
                mergeObjectsByCategoryId(
                    template?.pdf_data?.filter((category) => {
                        return category?.type === "MediaUploader" && category;
                    })
                )?.forEach((item) => {
                    if (item.value.length !== 0) {
                        item.value?.forEach((image) => {
                            if (image?.onlineUrl?.startsWith(templateMediaString) || image?.thumbnail?.startsWith(templateMediaString)) {
                                return;
                            }
                            let times_used = 1;
                            if (image?.is_deleted === 1) {
                                times_used = 0;
                            }
                            if (image?.is_report_media_library_file) {
                                media.push({ ...image, onlineUrl: image?.online_url, thumbnail: image?.thumbnail_url, type: image?.media_type, times_used: times_used });
                            } else {
                                media?.push({ ...image, online_url: image?.onlineUrl, thumbnail_url: image?.thumbnail, media_type: image?.type, times_used: times_used, template_media: true });
                            }
                        });
                    } else return null;
                });
            }
        });
        let mediaWithOriginal = [];
        media.forEach((mediaItem) => {
            const mediaDeletedFromRML = mediaItem?.is_deleted_from_rml || 0;
            const mediaIndex = mediaWithOriginal.findIndex((itm) => {
                return mediaItem.uuid === itm.uuid;
            });
            const mediaIndexByName = mediaWithOriginal.findIndex((itm) => {
                return mediaItem.name === itm.name;
            });
            if (mediaIndex !== -1) {
                mediaWithOriginal[mediaIndex]["isUserMade"] = true;
                const newItemIsDeleted = mediaItem?.is_deleted || 0;
                const mediaIndexLocal = mediaWithOriginal.findIndex((itm) => {
                    return mediaItem.uuid === itm.uuid;
                });
                mediaWithOriginal[mediaIndexLocal].times_used = mediaItem.times_used;
                if (newItemIsDeleted === 0 && mediaItem?.template_media && mediaIndexLocal !== -1) {
                    if (mediaItem?.edited === false) {
                        mediaWithOriginal[mediaIndexLocal].times_used = (mediaWithOriginal[mediaIndexLocal].times_used || 0) + 1;
                    }
                    mediaWithOriginal[mediaIndexLocal]["isUserMade"] = true;
                    if (mediaWithOriginal[mediaIndexLocal].updated_at < mediaItem?.updated_at) {
                        mediaWithOriginal[mediaIndexLocal].updated_at = mediaItem?.updated_at;
                    }
                }
                // add only edited
                if (mediaItem?.edited && mediaDeletedFromRML !== 2 && mediaDeletedFromRML !== 3) {
                    if (mediaIndexByName === -1) {
                        mediaWithOriginal.push({
                            ...mediaItem,
                            uuid: uuidv4(),
                            created_at: mediaItem?.updated_at,
                            times_used: mediaItem?.is_deleted ? 0 : 1,
                        });
                    }
                }
            } else {
                const mediaDeletedFromRML = mediaItem?.is_deleted_from_rml || 0;
                if (mediaItem?.edited) {
                    //store original as well
                    if (mediaDeletedFromRML === 0 || mediaDeletedFromRML === 2) {
                        let originalImage = {
                            ...mediaItem,
                            thumbnail: mediaItem.OriginThumbnail,
                            newUrl: mediaItem?.OriginUrl,
                            onlineUrl: mediaItem?.OriginUrl,
                            id: uuidv4(),
                            name: mediaItem?.OrginName || mediaItem?.orginName,
                            uploaded_by: mediaItem?.edited_by,
                            edited: false,
                            editCount: 0,
                            times_used: 0,
                            isUserMade: true,
                        };
                        const mediaIndexByNameLocal = mediaWithOriginal.findIndex((itm) => {
                            // An original without a name (older edits lost it) would otherwise match every nameless item and be dropped.
                            return originalImage.name ? originalImage.name === itm.name : originalImage.onlineUrl === itm.onlineUrl;
                        });
                        if (mediaIndexByNameLocal === -1) {
                            mediaWithOriginal.push(originalImage);
                        }
                    }
                    //push edited if 0 or 1
                    if (mediaDeletedFromRML === 0 || mediaDeletedFromRML === 1) {
                        const editedItem = { ...mediaItem, created_at: mediaItem?.updated_at, times_used: 1 };
                        if (mediaIndexByName === -1) {
                            mediaWithOriginal.push(editedItem);
                        }
                    }
                } else {
                    if (mediaDeletedFromRML !== 1 && mediaDeletedFromRML !== 3) {
                        if (mediaIndexByName === -1) {
                            mediaWithOriginal.push(mediaItem);
                        }
                    }
                }
            }
        });
        return mediaWithOriginal?.filter((item) => item?.online !== "offline" && item?.is_deleted_from_rml !== 3);
    };


    //filter button change
    const handleFilterButtonChange = (id, type, sortType, initialData) => {
        // Sets the selected id
        setSelectedId(id);
        // If the selected id is 'All'
        let result;
        if (id === 'All') {
            // Sets the report library data to the original data
            result = initialData;
        }
        // If the selected id is 'Images'
        else if (id === 'Images') {
            // Filters the original data to get the images only and sets the report library data to the result
            result = initialData?.filter(item => item?.media_type?.startsWith("image/") || item?.type?.startsWith("image/"));
        }
        // If the selected id is 'Videos'
        else if (id === 'Videos') {
            // Filters the original data to get the videos only and sets the report library data to the result
            result = initialData?.filter(item => item?.media_type?.startsWith("video/") || item?.type?.startsWith("video/"));
        }
        handleUsedAndUnusedMedia(id, type, sortType, result)
    }

    //filter used and unused
    const handleUsedAndUnusedMedia = (id, type, sortType, result) => {
        let ResultData = result;
        if (type === 'All') {
            ResultData = result;
        }
        else if (type === 'Used') {
            let UsedReportMediaFiles = ResultData?.filter((e) => e.times_used > 0 || e?.times_used === undefined)
            ResultData = UsedReportMediaFiles
        }
        else if (type === 'Unused') {
            let UnusedReportMediaFiles = ResultData?.filter((e) => e?.times_used === 0 || e?.times_used === null || e?.times_used === undefined);
            ResultData = UnusedReportMediaFiles
        }
        else if (typeof type === 'number') {
            ResultData = ResultData.filter(item => item?.uploaded_by === type);
        }

        SortReportMediaData(id, type, sortType, ResultData);
    }

    const parseDate = (dateString) => {
        if (!dateString?.includes("T")) {
            dateString = dateString?.replace(" ", "T") + ".000Z";
        }
        return new Date(dateString);
    };

    const SortReportMediaData = (id, type, sortType, result) => {
        // Ensure every item has a times_used key
        let ResultData = result;
        if (sortType === 'Most used') {
            ResultData = result?.filter((data) => data?.is_deleted !== 1)?.sort((a, b) => b?.times_used - a?.times_used); // Sort by times_used
        }
        else if (sortType === "Newest") {
            ResultData = result?.sort((a, b) => (parseDate(b.created_at ?? b.updated_at) - parseDate(a.created_at ?? a.updated_at)) || (Number(Boolean(b.edited)) - Number(Boolean(a.edited))));
        }
        else if (sortType === 'Oldest') {
            ResultData = result?.sort((a, b) => (parseDate(a.created_at ?? a.updated_at) - parseDate(b.created_at ?? b.updated_at)) || (Number(Boolean(a.edited)) - Number(Boolean(b.edited))));
        }
        else if (sortType === 'File name') {
            ResultData = result?.sort((a, b) => a.name.localeCompare(b.name));
        }
        return setReportLibraryData(ResultData)
    }

    const callInitiateAPI = async () => {
        let sessionAssociateCompanyKey = Base64.decode(sessionStorage.getItem('AC'));
        let guid = sessionStorage.getItem('guid')
        let sessionUserId = Base64.decode(sessionStorage.getItem('UI'));
        dispatch(getInspectionDataWithOutLoader({ guid: guid, associate_company: sessionAssociateCompanyKey, user_id: sessionUserId }))
    }

    useEffect(() => {
        if (storeData?.mediaEdited) {
            storeData.mediaEdited = false;
        } else {
            // callInitiateAPI()
        }
    }, [])


    // const previousResultLength = useRef(null);

    useEffect(() => {
        if (storeData) {
            let result = FilterCommentNLineMedia();
            setRLInititalData(result);
            handleFilterButtonChange(selectedId, selectedType, sortType, result)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storeData]);



    useEffect(() => {
        handleFilterButtonChange(selectedId, selectedType, sortType, RLInitialData);
    }, [selectedId, selectedType, sortType, RLInitialData])

    return (
        <div>
            {/* Conditionally render the open sidebar button */}
            {!isOpen && <div onClick={() => { setIsOpen(true); dispatch(reportLibrarySideBarToggle(true)) }} className="gallery-icon-hover"><Gallery /></div>}
            {/*
                Motion div to animate the width of the sidebar
                Pass in the isOpen state to the animation
                Set the initial state to be open
                Set the hidden state to be true when the animation starts
                Set the hidden state to be the opposite of isOpen when the animation is complete
                Set the transition to be ease
            */}
            <motion.div
                hidden={hidden}
                initial={false}
                onAnimationStart={() => setHidden(false)}
                onAnimationComplete={() => setHidden(!isOpen)}
                animate={{ width: isOpen ? isMobile ? '100%' : isTab ? 290 : 375 : 0 }}
                style={{ width: isOpen ? isMobile ? '100%' : isTab ? 290 : 375 : 0, transition: 'ease' }}
            >
                {/* Conditionally render the sidebar content */}
                {isOpen && <Grid container>
                    <Grid item xs={12}>
                        <Grid container sx={{ p: { xs: "10px", md: "7px", lg: "10px" }, mt: isMobile ? 0 : -1 }}>
                            <Grid item xs={6}>
                                <Typography className="rl-header-title">REPORT MEDIA LIBRARY</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                {value !== 2 && <CloseIcon onClick={() => { setIsOpen(false); dispatch(reportLibrarySideBarToggle(false)); }} className="rl-header-close-icon" />}
                                {value === 2 && (
                                    <div
                                        onClick={() => {
                                            setIsOpen(false);
                                            dispatch(reportLibrarySideBarToggle(false));
                                        }}
                                        style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", }}
                                        className="rl-header-close-icon"
                                    >
                                        <CloseIconAi />
                                    </div>
                                )}
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 2 }}>
                                <Grid container spacing={{ xs: 1, md: 0.5, lg: 0.5 }}>
                                    {name !== "Defect Finder" &&
                                        <Grid item xs={6} sx={{ ml: -1.3 }}>
                                            <RLButtonGroup
                                                // Pass in the report library data, setReportLibraryData, and allReportLibraryData
                                                sortType={sortType}
                                                selectedId={selectedId}
                                                selectedType={selectedType}
                                                setSelectedId={setSelectedId}
                                                RLInitialData={RLInitialData}
                                                handleFilterButtonChange={handleFilterButtonChange}
                                            />
                                        </Grid>
                                    }
                                    <Grid item xs={3.2} sx={{ ml: name === "Defect Finder" ? 0 : -1, mr: name === "Defect Finder" ? .5 : 0 }}>
                                        <SortTextField
                                            sortType={sortType}
                                            selectedId={selectedId}
                                            selectedType={selectedType}
                                            setSelectedType={setSelectedType}
                                            RLInitialData={RLInitialData}
                                            userDataList={storeData?.userDataList?.filter(user =>
                                                RLInitialData?.some(media => media.uploaded_by === user.user_id)
                                            )}
                                            handleFilterButtonChange={handleFilterButtonChange}
                                        />
                                    </Grid>
                                    <Grid item xs={2.8} ml={0}>
                                        {/* will be available in next release */}
                                        <FilterSortTextField
                                            sortType={sortType}
                                            selectedId={selectedId}
                                            selectedType={selectedType}
                                            setSortType={setSortType}
                                            RLInitialData={RLInitialData}
                                            handleFilterButtonChange={handleFilterButtonChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider className="rl-divider" />
                    </Grid>
                    <Grid item xs={12} sx={{ p: { xs: "10px", md: "7px", lg: "5px" } }}>
                        <Typography className="rl-content-desc">{value === 2 ? "Drag and drop images, click to select multiple (10 max)" : "Drag and drop images to lines or comments"}.</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <RMLGallery
                            // Pass in the bucket URL and the report library data
                            selectedImages={selectedImages}
                            setOnDragToggle={setOnDragToggle}
                            setSelectedImages={setSelectedImages}
                            reportLibraryData={reportLibraryData}
                            selectedMediaFiles={selectedMediaFiles}
                            setSelectedMediaFiles={setSelectedMediaFiles}
                            bucketUrlWRW={storeData?.inspectionData?.data?.bucket_url}
                            bucketUrlPortal={storeData?.inspectionData?.data?.bucket_url_2}
                            type={name}
                        />
                    </Grid>
                </Grid>}
            </motion.div>
        </div >
    );
}

export default ReportLibrarySideBar;